module.exports = __webpack_public_path__ + "img/attractions-salon.a9f0e2b7.jpg";